/**
 * Ortak site: kampanya yüzü (bu CRA kök `/`) + gerçek uygulama `demaxtore-main`
 * içindeki Next.js paneli `/panel` altında (aynı hostname, nginx ile proxy).
 */
export const MARKETING_PANEL = {
  signIn: "/panel/auth/sign-in",
  signUp: "/panel/auth/sign-up",
  createBid: "/panel/productionRequests/create",
  dashboard: "/panel/dashboard",
};
